import React, { Component } from "react";
import Input from "../common/Input";
import { api, postOptions } from "../common/server";
import { NavLink, Redirect } from "react-router-dom";
import logo from "../assets/rizevoIcon.svg";
import { connect } from "react-redux";
import HomeSvg from "./HomeSvg";

export default connect()(
  class Forgot extends Component {
    state = {
      redirect: false,
      loading: false,
      errors: {},
    };
    done = () => {
      this.setState({ redirect: "/" });
    };
    reset = (ev) => {
      ev.preventDefault();
      this.setState({ errors: {}, loading: true });
      const form = ev.currentTarget;
      const formData = {
        email: form.email.value
      };
      const body = JSON.stringify(formData);
      fetch(`${api}/password/forgot`, Object.assign(postOptions, { body }))
        .then((res) => {
          this.setState({ loading: false });
          return res.json();
        })
        .then((obj) => {
          if (obj.success === false) {
            this.setState({
              errors: { ...this.state.errors, message: obj.errors[0]?.message ?? obj.message },
            });
          } else {
            window.$.notify(obj.message ?? "Password Reset link has been sent to your email. It may take up to 5 minutes to arrive.", "success-alert");
            // setTimeout(this.done, 0);
          }
        });
    };
    render() {
      return (
        <div className="login-page-container">
          <div className="login-page-container-header flex">
            <a href="https://kindlybook.com" className="flex co-pink">
              <HomeSvg /> Go to website
            </a>

            <div>
              <NavLink
                to={{
                  pathname: "/signup",
                  search: this.props.location.search,
                }}
                className="default-btn"
              >
                Sign Up
              </NavLink>
            </div>
          </div>
          <div className="form-page login-page">
            {this.state.redirect ? (
              <Redirect
                to={{
                  pathname: `${this.state.redirect}`,
                  search: this.props.location.search,
                }}
              ></Redirect>
            ) : (
              ""
            )}
            <div className="heading">
              <img className="logo" src={logo} alt="" />
              <h1>Forgot your Password?              </h1>
              <p>
                Lets get you back in
              </p>


            </div>

            <div>
              <div className="flex tab-container ">

              </div>
              <div className="form-container card">
                <form onSubmit={this.reset}>
                  <Input
                    label="Email address"
                    placeholder="you@example.com"
                    type="email"
                    name="email"
                    autoFocus={true}
                    error={this.state.errors.message}
                    required
                  />

                  <div className="flex center space-btw">

                    <button
                      className={
                        "default " + (this.state.loading ? "loading" : "")
                      }
                    >
                      Reset Password
                    </button>
                  </div>
                  <div className=" dsk" style={{ marginTop: '10px' }}>
                    Remembered?{" "}
                    <NavLink
                      to={{
                        pathname: "/login",
                        search: this.props.location.search,
                      }}
                      className="underline"
                    >
                      Sign In Instead
                    </NavLink>
                  </div>
                </form>
              </div>
            </div>

            <div className="footer mbl">
              Remember ?
              <NavLink
                to={{ pathname: "/login", search: this.props.location.search }}
                className="underline"
              >
                Sign In
              </NavLink>
            </div>
          </div>
        </div>
      );
    }
  }
);
